import { render, staticRenderFns } from "./project-tag-checkbox.vue?vue&type=template&id=538c79d2&scoped=true"
import script from "./project-tag-checkbox.vue?vue&type=script&lang=js"
export * from "./project-tag-checkbox.vue?vue&type=script&lang=js"
import style0 from "./project-tag-checkbox.vue?vue&type=style&index=0&id=538c79d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538c79d2",
  null
  
)

export default component.exports